import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  createFormationProApi,
  deleteFormationProApi,
  fetchFormationPros,
  updateFormationProApi,
} from "../services/formationProService";

const FORMATION_PROS_QUERY_KEY = ["formation-pros"];

export const useFormationPros = () =>
  useQuery({
    queryKey: FORMATION_PROS_QUERY_KEY,
    queryFn: fetchFormationPros,
  });

export const useCreateFormationPro = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createFormationProApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORMATION_PROS_QUERY_KEY });
      toast.success("Formation bien ajoutée", { autoClose: 3000 });
    },
    onError: (err) => {
      const msg = err?.message || "Formation non ajoutée";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};

export const useUpdateFormationPro = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }) => updateFormationProApi(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORMATION_PROS_QUERY_KEY });
      toast.success("Formation bien modifiée", { autoClose: 3000 });
    },
    onError: (err) => {
      const msg = err?.message || "Formation non modifiée";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};

export const useDeleteFormationPro = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteFormationProApi(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FORMATION_PROS_QUERY_KEY });
      toast.success("Formation professionnelle supprimée avec succès", {
        autoClose: 3000,
      });
    },
    onError: (err) => {
      const msg =
        err?.message ||
        "Une erreur est survenue lors de la suppression de la formation professionnelle";
      toast.error(msg, { autoClose: 3000 });
    },
  });
};
